import type { SportFilter, TeamConferenceFilter } from '@on3/api';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import Filter, { makeList } from '../Filters/Filter';
import FilterTeams from '../Filters/FilterTeams';
import styles from './PredictionCenterList.module.scss';

interface IPredictionCenterFiltersProps {
  years: number[];
  sports: SportFilter[];
  teams?: TeamConferenceFilter[];
}
const allFilterObject = { key: 0, name: 'all' };

export const PredictionCenterFilters = ({
  years,
  sports,
  teams,
}: IPredictionCenterFiltersProps) => {
  const router = useRouter();
  const showAllExpertPredictionRoute = router.asPath.includes(
    '/expert-predictions/',
  );
  const { year, sport } = router.query;
  const makeYears = makeList(years);

  const filterYears = useMemo(() => [allFilterObject, ...makeYears], []);
  const filterSports = useMemo(() => [allFilterObject, ...sports], []);

  return (
    <div className={styles.filterWrapper}>
      {showAllExpertPredictionRoute && (
        <FilterTeams
          collegePathName="/college/[college]/expert-predictions/[sport]/[year]/"
          name="college"
          teams={teams}
        />
      )}
      <Filter
        list={filterYears}
        name="year"
        selected={`${year ? year : 'years'}`}
      />
      <Filter
        list={filterSports}
        name="sport"
        selected={`${sport ? sport : 'sports'}`}
      />
    </div>
  );
};
